import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { Boxes, PlusCircle, Pencil, Trash2, XCircle, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

function StokuModal({ produkt, onClose }) {
  const { roli, lokacion_id } = useAuth();
  const [filterLokacion, setFilterLokacion] = useState('');
  const [form, setForm] = useState({
    madhesi_id: '',
    ngjyra_id: '',
    sasia: '',
    orig_madhesi_id: '',
    orig_ngjyra_id: '',
    lokacion_id: ''
  });
  const [search, setSearch] = useState('');
  const [editKey, setEditKey] = useState(null);

  const { data: stokData, execute: refetchStok } = useApi(
    () => {
      const params = roli === 'admin' && filterLokacion ? { lokacion_id: filterLokacion } : {};
      return apiService.get(`/stok/produkt/${produkt.id}`, { params });
    },
    [produkt?.id, filterLokacion],
    { immediate: !!produkt?.id, showNotifications: false }
  );

  const { data: madhesiteData } = useApi(
    () => apiService.get('/madhesite'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: ngjyratData } = useApi(
    () => apiService.get('/ngjyrat'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: lokacionetData } = useApi(
    () => apiService.get('/lokacionet'),
    [],
    { immediate: roli === 'admin', showNotifications: false }
  );

  const stok = Array.isArray(stokData) ? stokData : (stokData?.data || []);
  const madhesite = Array.isArray(madhesiteData) ? madhesiteData : (madhesiteData?.data || []);
  const ngjyrat = Array.isArray(ngjyratData) ? ngjyratData : (ngjyratData?.data || []);
  const lokacionet = Array.isArray(lokacionetData) ? lokacionetData : (lokacionetData?.data || []);

  const { execute: updateStok } = useMutation(
    async (data) => {
      return await apiService.post(`/produkte/${produkt.id}/stok`, data);
    },
    {
      successMessage: 'Stoku u ruajt me sukses!'
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateStok({
        madhesi_id: form.madhesi_id,
        ngjyra_id: form.ngjyra_id,
        sasia: parseInt(form.sasia),
        orig_madhesi_id: form.orig_madhesi_id,
        orig_ngjyra_id: form.orig_ngjyra_id,
        lokacion_id: roli === 'admin' ? (form.lokacion_id || filterLokacion) : lokacion_id
      });
      setForm({ madhesi_id: '', ngjyra_id: '', sasia: '', orig_madhesi_id: '', orig_ngjyra_id: '', lokacion_id: '' });
      setEditKey(null);
      refetchStok();
    } catch (err) {
      // Error handled by useMutation
    }
  };

  const handleEdit = (s) => {
//     if (roli === 'admin' && !lokacion_id) {
//   alert('Zgjidhni lokacionin për të vazhduar');
//   return;
// }
    setForm({
      madhesi_id: s.madhesi_id,
      ngjyra_id: s.ngjyra_id,
      sasia: s.sasia,
      orig_madhesi_id: s.madhesi_id,
      orig_ngjyra_id: s.ngjyra_id,
      lokacion_id: roli === 'admin' ? (filterLokacion || '') : lokacion_id
    });
    setEditKey(`${s.madhesi_id}-${s.ngjyra_id}`);
  };

  const { execute: deleteStok } = useMutation(
    async ({ madhesi_id, ngjyra_id, lokacion_id }) => {
      return await apiService.delete(`/produkte/${produkt.id}/stok`, {
        data: { madhesi_id, ngjyra_id, lokacion_id }
      });
    },
    {
      successMessage: 'Stoku u fshi me sukses!'
    }
  );

  const handleDelete = async (madhesi_id, ngjyra_id, rowLokacionId) => {
    if (!window.confirm("A jeni i sigurt që doni ta fshini këtë stok?")) return;
    try {
      await deleteStok({
        madhesi_id,
        ngjyra_id,
        lokacion_id: roli === 'admin'
          ? (filterLokacion || form.lokacion_id || rowLokacionId)
          : lokacion_id
      });
      refetchStok();
    } catch (err) {
      // Error handled by useMutation
    }
  };
const filteredStok = stok.filter((item) => {
  const madhesiEmri = (item.madhesi?.emri ?? '').toLowerCase();
  const ngjyraEmri = (item.ngjyra?.emri ?? '').toLowerCase();
  const matchesSearch = madhesiEmri.includes(search) || ngjyraEmri.includes(search);
  const lokacionMatch = !filterLokacion || item.lokacion_id == filterLokacion;
  return matchesSearch && lokacionMatch;
});


  // const filteredStok = stok.filter((item) =>
  //   item.madhesi.emri.toLowerCase().includes(search) ||
  //   item.ngjyra.emri.toLowerCase().includes(search)
  // );

  return (
    <div className="fixed inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="card-premium w-full max-w-5xl overflow-y-auto max-h-[90vh] p-6 space-y-6 animate-fadeIn">
        <div className="flex justify-between items-center border-b border-gray-200 dark:border-dark-700 pb-4">
          <h2 className="text-3xl font-bold text-gradient-logo flex items-center gap-3 flex-wrap">
            <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
              <Boxes size={28} className="text-primary-600 dark:text-primary-400" />
            </div>
            Stoku i Produktit: <span className="text-primary-600 dark:text-primary-400">{produkt.emri}</span>
          </h2>
          <button onClick={onClose} className="text-gray-400 dark:text-gray-500 hover:text-red-600 dark:hover:text-red-400 transition-colors">
            <XCircle size={26} />
          </button>
        </div>

        

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <select value={form.madhesi_id ?? ''} onChange={(e) => setForm({ ...form, madhesi_id: e.target.value || null })}
            className="input-premium">
            <option value="">Pa madhësi</option>
            {madhesite.map((m) => (
              <option key={m.id} value={m.id}>{m.emri}</option>
            ))}
          </select>
          <select value={form.ngjyra_id ?? ''} onChange={(e) => setForm({ ...form, ngjyra_id: e.target.value || null })}
            className="input-premium">
            <option value="">Pa ngjyre</option>
            {ngjyrat.map((n) => (
              <option key={n.id} value={n.id}>{n.emri}</option>
            ))}
          </select>
          <input
            type="number"
            min="0"
            placeholder="Sasia"
            value={form.sasia}
            onChange={(e) => setForm({ ...form, sasia: e.target.value })}
            className="input-premium"
            required
          />
          {roli === 'admin' && (
            <select
              value={form.lokacion_id || filterLokacion}
              onChange={(e) => setForm({ ...form, lokacion_id: e.target.value })}
              className="input-premium"
              required
            >
              <option value="">Zgjidh lokacionin</option>
              {lokacionet.map(l => (
                <option key={l.id} value={l.id}>{l.emri}</option>
              ))}
            </select>
          )}
          <button type="submit" className="btn-primary flex items-center gap-2 justify-center">
            <PlusCircle size={18} />
            {editKey ? "Përditëso" : "Shto"}
          </button>
        </form>

        <div className="grid md:grid-cols-2 gap-4">
          <div className="relative w-full">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500" />
            <input
              type="text"
              placeholder="Kërko madhësi ose ngjyrë..."
              value={search}
              onChange={(e) => setSearch(e.target.value.toLowerCase())}
              className="input-premium pl-10"
            />
          </div>
          {roli === 'admin' && (
            <div className="w-full">
              <select
                value={filterLokacion}
                onChange={(e) => setFilterLokacion(e.target.value)}
                className="input-premium"
              >
                <option value="">Të gjithë lokacionet</option>
                {lokacionet.map(l => <option key={l.id} value={l.id}>{l.emri}</option>)}
              </select>
            </div>
          )}
        </div>

        <div className="card-premium overflow-x-auto p-0">
          <table className="table-premium">
            <thead>
              <tr>
                <th>Madhësia</th>
                <th>Ngjyra</th>
                <th>Sasia</th>
                <th>Veprime</th>
              </tr>
            </thead>
            <tbody>
              {filteredStok.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-8 text-gray-500 dark:text-gray-400">
                    Nuk ka stok për këtë produkt
                  </td>
                </tr>
              ) : (
                filteredStok.map((s) => (
                  <tr key={`${s.madhesi_id ?? 'n'}-${s.ngjyra_id ?? 'n'}-${s.lokacion_id ?? ''}`}>
                    <td>{s.madhesi?.emri ?? '–'}</td>
                    <td>{s.ngjyra?.emri ?? '–'}</td>
                    <td className={`font-semibold ${s.sasia > 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>{s.sasia}</td>
                    <td>
                      <div className="flex gap-2">
                        {(roli !== 'admin' || filterLokacion) && (
                          <button onClick={() => handleEdit(s)} className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 inline-flex items-center gap-1 transition-colors">
                            <Pencil size={16} /> Edito
                          </button>
                        )}
                        <button onClick={() => handleDelete(s.madhesi_id, s.ngjyra_id, s.lokacion_id)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 inline-flex items-center gap-1 transition-colors">
                          <Trash2 size={16} /> Fshi
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default StokuModal;
